enum TagSizeEnum {
  sm = "py-[0.125rem] px-[0.375rem] text-[0.625rem]",
  md = "py-[0.25rem] px-[0.5rem] text-[0.875rem]",
  lg = "py-[0.375rem] px-[0.75rem] text-[1rem]",
}
export default TagSizeEnum;
